import utils from '@eitje/utils'
import {Layout} from '~/components'
import {useFilterContext} from './context'
import {Filter, FiltersLabel, ClearFiltersButton} from './components'
import _ from 'lodash'

const background = '#EFF3F6' // Custom background, put in web_components if using more often.

const STYLES = {
	fullScreen: {padding: '- - - 10', margin: '- - -1 -', borderBottom: true, style: {background, marginBottom: '-1px'}},
	floating: {margin: '2 - - -', borderTop: true},
}

export const Filters = () => {
	const {name, filterTaxonomies, fullScreen, layoutProps} = useFilterContext()

	// Deduce which styles should be used. In the future, we may also accept custom styling props which overwrite the default types.
	const stylingDecider = fullScreen ? 'fullScreen' : 'floating'
	const styles = STYLES[stylingDecider]

	// Don't show if there are no filters (e.g. users-out-of-service page in single env org).
	const noFilters = _.isEmpty(filterTaxonomies)
	if (noFilters) return null

	const classNames = utils.makeCns('filters', `${name}-filters`)

	return (
		<Layout className={classNames} height={32} width="full" {...styles} {...layoutProps}>
			<Layout data-intercom-target="filters">
				<FiltersLabel />
				{filterTaxonomies.map(props => (
					<Filter {...props} />
				))}
				<ClearFiltersButton />
			</Layout>
		</Layout>
	)
}
